//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function getShortenedTableVersion(variableValue: string, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/document-utilities/GetShortenedTableVersion";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(variableValue);

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetShortenedTableVersion,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigGetShortenedTableVersion?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetShortenedTableVersion(_response);
    });
}

function processGetShortenedTableVersion(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function setDocumentTableRepeatHeader(documentContent: string, tableIndex: number, repeat?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/document-utilities/{tableIndex}/set-repeat-header?";
    if (tableIndex === undefined || tableIndex === null)
      throw new Error("The parameter 'tableIndex' must be defined.");
    url_ = url_.replace("{tableIndex}", encodeURIComponent("" + tableIndex));
    if (repeat === null)
        throw new Error("The parameter 'repeat' cannot be null.");
    else if (repeat !== undefined)
        url_ += "repeat=" + encodeURIComponent("" + repeat) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(documentContent);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSetDocumentTableRepeatHeader,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSetDocumentTableRepeatHeader?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSetDocumentTableRepeatHeader(_response);
    });
}

function processSetDocumentTableRepeatHeader(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function getPlainTextTable(body: Types.GetPlainTextTableRequestBody, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/document-utilities/plain-text-table";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeGetPlainTextTableRequestBody(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPlainTextTable,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigGetPlainTextTable?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPlainTextTable(_response);
    });
}

function processGetPlainTextTable(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function applyVariablesToDocument(dto: Types.ApplyVariablesToDocumentDto, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/document-utilities/apply-to-document";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeApplyVariablesToDocumentDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigApplyVariablesToDocument,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigApplyVariablesToDocument?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processApplyVariablesToDocument(_response);
    });
}

function processApplyVariablesToDocument(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}
let _requestConfigGetShortenedTableVersion: Partial<AxiosRequestConfig> | null;
export function getGetShortenedTableVersionRequestConfig() {
  return _requestConfigGetShortenedTableVersion;
}
export function setGetShortenedTableVersionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetShortenedTableVersion = value;
}
export function patchGetShortenedTableVersionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetShortenedTableVersion = patch(_requestConfigGetShortenedTableVersion ?? {});
}

let _requestConfigSetDocumentTableRepeatHeader: Partial<AxiosRequestConfig> | null;
export function getSetDocumentTableRepeatHeaderRequestConfig() {
  return _requestConfigSetDocumentTableRepeatHeader;
}
export function setSetDocumentTableRepeatHeaderRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSetDocumentTableRepeatHeader = value;
}
export function patchSetDocumentTableRepeatHeaderRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSetDocumentTableRepeatHeader = patch(_requestConfigSetDocumentTableRepeatHeader ?? {});
}

let _requestConfigGetPlainTextTable: Partial<AxiosRequestConfig> | null;
export function getGetPlainTextTableRequestConfig() {
  return _requestConfigGetPlainTextTable;
}
export function setGetPlainTextTableRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPlainTextTable = value;
}
export function patchGetPlainTextTableRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPlainTextTable = patch(_requestConfigGetPlainTextTable ?? {});
}

let _requestConfigApplyVariablesToDocument: Partial<AxiosRequestConfig> | null;
export function getApplyVariablesToDocumentRequestConfig() {
  return _requestConfigApplyVariablesToDocument;
}
export function setApplyVariablesToDocumentRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigApplyVariablesToDocument = value;
}
export function patchApplyVariablesToDocumentRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigApplyVariablesToDocument = patch(_requestConfigApplyVariablesToDocument ?? {});
}